interface ConstantProps {
  [key: string]: JSX.Element;
}

export const MARKETING_HISTORY: ConstantProps = {
  '2025.11.30': (
    <div className="terms-body">
      &apos;주식회사 오픈서베이&apos; 는 (이하 &apos;회사&apos;는)
      &apos;정보통신망 이용촉진 및 정보보호에 관한 법률&apos;,
      &apos;개인정보보호법&apos;등 관계 법령에 따라 광고성 정보를 전송하기 위해
      수신자의 사전 수신 동의를 받고 있으며, 광고성 정보 수신자의 수신 동의
      여부를 정기적으로 확인합니다. 다만 동의하지 않을 경우, 상품/서비스 소개 및
      권유, 사은행사, 판촉행사 등 이용목적에 따른 혜택에 제한이 있을 수
      있습니다.
      <p className="first_level">01. 목적</p>
      <p>- 앱푸시 및 문자 메시지(알림톡)을 통한 광고성 정보 전송</p>
      <p>- 오베이 및 제휴사 소식, 혜택, 이벤트, 광고 등 마케팅에 활용</p>
      <p>
        - 오베이 서비스 이용에 따른 정보성 안내는 수신 동의 여부와 무관하게
        제공됩니다.
      </p>
      <p className="first_level">02. 이용항목</p>
      <p>- 휴대폰 번호</p>
      <p className="first_level">03. 보유 및 이용기간</p>
      <p>- 마케팅 활용 동의일로부터 오베이 탈퇴 또는 동의철회 시까지</p>
      <p className="second_level">
        * 본 동의는 선택동의로서 거부하실 수 있으며, 거부하시더라도 서비스
        이용에는 제한이 없습니다.
        <br />* 마케팅 정보 수신 동의/해제는 언제든지 앱의 설정 메뉴에서
        변경하실 수 있습니다.
        <br />
        (오베이 앱 내 : 더보기 &gt; 서비스 동의 &gt; 마케팅 활용 동의)
      </p>
      <br />
    </div>
  ),
};
